exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MasterRange_MasterRange__2zNN-{margin-bottom:10px;font-size:14px;line-height:20px;font-weight:400;color:#626469;margin-bottom:20px}.MasterRange_MasterRange__2zNN-:last-child{margin-bottom:0}.MasterRange_MasterRange__2zNN- .MasterRange_boldArea__2ObF4{font-weight:700}", ""]);

// exports
exports.locals = {
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"MasterRange": "MasterRange_MasterRange__2zNN-",
	"boldArea": "MasterRange_boldArea__2ObF4"
};